import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class ProjectService extends AbstractService {

	static projectsApi = NexusService.projectsApi;

	static getAll(queryParams) {
		const getReq = {
			status: queryParams.status,
			pageNumber: queryParams.pageNumber,
			projectId: queryParams.projectId,
			includeAll: queryParams.includeAll,
			name: queryParams.name,
			clientName: queryParams.clientName,
			clientId: queryParams.clientId,
			displayCount: queryParams.displayCount,
			clientContactId: queryParams.clientContactId,
			minimal: queryParams.minimalData,
			getJobTotals: queryParams.getJobTotals,
		};

		return this.projectsApi.getPaginatedProjects(getReq).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static getProject(id) {
		return this.projectsApi.getProject({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	// TODO: replace this legacy method on QuickAddProjectModal
	static save({
		id,
		additionalAgencyContact,
		projectName,
		projectNumber,
		clientSupervisor,
		agencySupervisor,
		agencySupervisorName,
		paymentTerms,
		description,
		status,
		client,
		isRKPay,
	}) {
		const isCreating = id === null || id === undefined;

		const payload = {
			Name: projectName,
			Description: description,
			PaymentTermsId: paymentTerms,
			AgencySupervisorContactId: agencySupervisor,
			ClientSupervisorContactId: clientSupervisor,
			ClientId: client,
			ProjectStatus: status,
			SecondaryProjectSupervisorModel: additionalAgencyContact,
			AgencySupervisorName: agencySupervisorName,
			ProjectNo: projectNumber,
			IsAgencyRKPayEnabled: isRKPay,
			IsWebApp: true,
		};

		if (isCreating) {
			return this.projectsApi.createProject({ projectCreatePayload: payload });
		}

		const updateReq = {
			id,
			projectUpdatePayload: payload,
		};

		return this.projectsApi.updateProject(updateReq);
	}

	static saveOrUpdate(data, id) {
		const isCreating = typeof id === "undefined";

		const payload = {
			Name: data.Name,
			Description: data.Description,
			PaymentTermsId: data.PaymentTermsId,
			AgencySupervisorContactId: data.AgencySupervisorContactId,
			ClientSupervisorContactId: data.ClientSupervisorContactId,
			ClientId: data.ClientId,
			ProjectStatus: data.ProjectStatus,
			SecondaryProjectSupervisorModel: data.SecondaryProjectSupervisorModel,
			AgencySupervisorName: data.AgencySupervisorName,
			ProjectNo: data.ProjectNo,
			IsAgencyRKPayEnabled: data.IsAgencyRKPayEnabled,
			IsWebApp: true,
		};

		if (isCreating) {
			return this.projectsApi.createProject({ projectCreatePayload: payload });
		}

		const updateReq = {
			id,
			projectUpdatePayload: payload,
		};

		return this.projectsApi.updateProject(updateReq);
	}

	static delete(id) {
		return this.projectsApi.deleteProject({ id }).then(response => {
			const apiResponse = {
				data: response,
			};

			return apiResponse;
		});
	}
}
